import React, { useEffect, useState } from "react";
import "./FloatingButtons.css";
import Chatbot from "./Chatbot";

const FloatingButtons = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [cookieConsentGiven, setCookieConsentGiven] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    const checkCookieConsent = () => {
      const consentCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("thriveCookieConsent="));
      setCookieConsentGiven(!!consentCookie);
    };

    checkMobile();
    checkCookieConsent();

    window.addEventListener("resize", checkMobile);
    window.addEventListener("cookieConsentChange", checkCookieConsent);

    return () => {
      window.removeEventListener("resize", checkMobile);
      window.removeEventListener("cookieConsentChange", checkCookieConsent);
    };
  }, []);

  // Hide buttons on mobile if cookie consent not given
  if (isMobile && !cookieConsentGiven) {
    return null;
  }

  return (
    <div className="floating-buttons-container">
      <Chatbot cookieAccepted={cookieConsentGiven} />
      <a
        href="https://wa.me/2348180996418"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp-btn"
        aria-label="Contact us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default FloatingButtons;
